import { DecimalNullableMeasurementViewModel } from "@vattenfall/self-service";

export class CampaignProductCardFinland {
  productId?: string;
  agreementName?: string;
  productType?: ProductType;
  monthlyBaseFee?: DecimalNullableMeasurementViewModel;
  discountedMonthlyBaseFee?: DecimalNullableMeasurementViewModel | null;
  electricityPrice?: DecimalNullableMeasurementViewModel;
  contractLength?: DecimalNullableMeasurementViewModel;
  discountLength?: DecimalNullableMeasurementViewModel;
  hideMonthlyCost?: boolean;
  energySourceName?: string;
  originFee?: DecimalNullableMeasurementViewModel;
  spotGuardFee?: DecimalNullableMeasurementViewModel;
}

export const SECONDARY_COLORS = <const>["darkgreen", "darkblue", "pink", "darkpurple", "green", "red", "purple"];
export type SecondaryColor = typeof SECONDARY_COLORS[number];
export type ProductType = "fixed" | "variable" | "spot";
